import { Label } from '@aibees/shared/components';
import type { LabelColor } from '@aibees/shared/components/label/types';
import { classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ProfileLabelCardProps as Props } from './types';

export const ProfileLabelCard = memo(
  ({ className, title, labels, colorMap }: Props) => {
    return (
      <Styled.Wrapper
        className={classnames('ProfileLabelCard', className)}
        sx={SX.root}
        xs={5.8}
        gap={1}
      >
        <Typography variant="body3" fontWeight={600}>
          {title}:
        </Typography>

        {labels.map((label, index) => (
          <Label
            key={index}
            variant="filled"
            size="xsmall"
            color={colorMap[label]?.color as LabelColor}
          >
            {label}
          </Label>
        ))}
      </Styled.Wrapper>
    );
  }
);

ProfileLabelCard.displayName = 'ProfileLabelCard';
